import { render, staticRenderFns } from "./CustomerPotentialTab.vue?vue&type=template&id=4d7c7e4f&scoped=true"
import script from "./CustomerPotentialTab.vue?vue&type=script&lang=js"
export * from "./CustomerPotentialTab.vue?vue&type=script&lang=js"
import style0 from "./CustomerPotentialTab.vue?vue&type=style&index=0&id=4d7c7e4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7c7e4f",
  null
  
)

export default component.exports